/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { StoresMapAction, StoresMapActionType } from '../actions/AStoresMap';
import { StoresForMap, StoresMapFilterParams, storeStatus } from '../api/stores/storesClientTypings';
import { BAKU_BOUNDS, BAKU_CENTER, DEFAULT_ZOOM } from '../../components/Map/consts';
import { Viewport } from '../../components/Map/typings';

const defaultSearchType = 'storeTaxNumbers';
const defaultStoreStatuses: storeStatus[] = ['ACTIVE', 'SUSPENDED'];

export interface StoresMapState {
    viewport: Viewport;
    stores: StoresForMap;
    filterParams: StoresMapFilterParams;
    changedFilterParams: StoresMapFilterParams;
    isLoading: boolean;
}

const initialState: StoresMapState = {
    viewport: {
        bounds: {
            ...BAKU_BOUNDS,
        },
        center: BAKU_CENTER,
        zoom: DEFAULT_ZOOM,
    },
    filterParams: {
        search_type: defaultSearchType,
        search_text: '',
        afterKeyId: null,
        limit: 10000,
        city: null,
        storeTypes: null,
        storeStatuses: defaultStoreStatuses,
    },
    changedFilterParams: null,
    stores: null,
    isLoading: false,
};

export function storeMapReducer(state: StoresMapState = initialState, action: StoresMapAction): StoresMapState {
    switch (action.type) {
        case StoresMapActionType.OPEN_STORES_MAP_PAGE:
            return {
                ...state,
                isLoading: true,
            };

        case StoresMapActionType.VIEWPORT_CHANGE:
            return {
                ...state,
                viewport: action.payload,
                isLoading:
                    state.filterParams.search_text === '' &&
                    state.filterParams.city === null &&
                    state.filterParams.storeTypes === null,
            };

        case StoresMapActionType.APPLY_FILTERS:
            return {
                ...state,
                filterParams: state.changedFilterParams ? { ...state.changedFilterParams } : { ...state.filterParams },
                changedFilterParams: null,
                isLoading: true,
            };

        case StoresMapActionType.CHANGE_FILTER_PARAMS:
            return {
                ...state,
                changedFilterParams: {
                    ...state.filterParams,
                    ...action.payload,
                },
            };

        case StoresMapActionType.FETCH_STORES_SUCCESS:
            return {
                ...state,
                stores: action.payload,
                isLoading: false,
            };

        case StoresMapActionType.FETCH_STORES_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case StoresMapActionType.EXIT_STORES_MAP_PAGE:
            return {
                ...state,
                stores: null,
            };

        default:
            break;
    }
    return state;
}
